import CoreAPI from "./coreAPI";

export type IRAAccountOpeningDataResponse = {
  iraAccountOpeningDataId: number;
  accountOpeningDataJson: string;
  status: string;
};

export type RecommendationResponse = {
  recommendation: Record<string, string>;
};

export default function APIIraRecommendation(api: CoreAPI) {
  return {
    async updateIRAAccountOpeningData({
      userId,
      destinationAccountId,
      data,
    }: {
      userId: string;
      destinationAccountId: string | number;
      data: Record<string, any>;
    }) {
      return api.authCall<IRAAccountOpeningDataResponse>({
        method: "POST",
        endpoint: `/api/userIdentity/${userId}/transfer/destinationAccount/${destinationAccountId}/iraAccountOpeningData`,
        body: data,
      });
    },
    async getIRARecommendation({ userId, data }: { userId: string; data: Record<string, any> }) {
      try {
        const res = await api.authCall<RecommendationResponse>({
          method: "POST",
          endpoint: `/api/userIdentity/${userId}/iraRecommendation`,
          body: data,
        });
        return res.recommendation;
      } catch (e) {
        console.error(e);
      }
    },
    async updateFuturemoneyConsent({
      // IRA PARTNERSHIP
      userId,
      iraAccountOpeningDataId,
    }: {
      userId: string;
      iraAccountOpeningDataId: string | number;
    }) {
      return await api.authCall({
        method: "POST",
        endpoint: `/api/userIdentity/${userId}/transfer/destinationAccount/iraAccountOpeningData/${iraAccountOpeningDataId}/updateConsent`,
      });
    },
    async getAccountOpeningData({
      userId,
      iraAccountOpeningDataId,
    }: {
      userId: string;
      iraAccountOpeningDataId: string | number;
    }) {
      try {
        return await api.authCall<IRAAccountOpeningDataResponse>({
          method: "GET",
          endpoint: `/api/userIdentity/${userId}/transfer/destinationAccount/iraAccountOpeningData/${iraAccountOpeningDataId}`,
        });
      } catch (e) {
        return {} as IRAAccountOpeningDataResponse;
      }
    },
  };
}
